import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function hotButtons() {
  const widgetName = 'hotButtons';
  const widgetOpts = typeof hotButtonsOpts === 'undefined' ? null : hotButtonsOpts;
  const wrapContainerClass = `${widgetName}-container-wrapper`;
  const $widget = $(`#${widgetName}`);

  if (!widgetOpts) {
    $(`.${wrapContainerClass}`).remove();
    missingWidget(widgetName);
    return;
  }

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: 'all',
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createHotButtons(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createHotButtons(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);

      $cardItem.find('.card-content').remove();
      $cardItem.append(`
        <div class="card-content">
          <div class="widget-title-wrapper">
            <span class="widget-title">
              ${Title}
            </span>
          </div>
        </div>`);

      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}
